import { Overview } from '../../../xgenerated'

export const filterOverviewsByComplianceFrameworkIds = (
  overviews: Overview[],
  complianceFrameworkIds: string[],
): Overview[] => {
  return complianceFrameworkIds && complianceFrameworkIds.length > 0
    ? overviews.filter((overview) => {
        return overview.complianceFrameworkIds.some(
          (complianceFrameworkId: string) =>
            complianceFrameworkIds.includes(complianceFrameworkId),
        )
      })
    : []
}
